export default __webpack_public_path__ + "static/media/auqui3.518ca78e.jpg";